import { useParams, useSearchParams } from "react-router-dom";

import { getLocations } from "features/LocationsPage/locations";

import css from "./styles.module.scss";

export const IntegrationPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = searchParams.get("lang") || "pl";

  const { city } = useParams();

  const locations = getLocations();

  console.log(locations[city].documents[lang].companies);

  return (
    <div className={css.IntegrationPage}>
      <iframe
        title="companies pdf"
        src={locations[city].documents[lang].companies}
        width="100%"
        height="100%"
        className={css.iframe}
      />
    </div>
  );
};
